var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedal = function SvgMedal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.551 16.602 3 1.5h9l6 12M25.45 16.6 33 1.5h-9l-6 12",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 34.5c5.799 0 10.5-4.701 10.5-10.5S23.799 13.5 18 13.5 7.5 18.201 7.5 24 12.201 34.5 18 34.5Z",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m18 18.573 1.764 3.573 3.942.573-2.853 2.781.673 3.927L18 27.573l-3.527 1.854.674-3.927-2.853-2.781 3.942-.573L18 18.573Z",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
};
export default SvgMedal;